import React from "react";
import Link from "gatsby-link";
import GatsbyConfig from "../../../gatsby-config.js";
import { isIOSDevice, isHawaiiTime } from "../../utils/app-helpers";

const { siteMetadata: config } = GatsbyConfig;

export default class SiteFooter extends React.Component {
  render() {
    const { trip, hidePolicies, hideTrips, hideNewsletter } = this.props;
    const tripData = trip ? config.trips[trip] : false;
    const tripLinks = [];
    const isHST = isHawaiiTime();
    const isIOS = isIOSDevice();

    Object.keys(config.trips).forEach((key) => {
      const data = config.trips[key];
      if (
        !data.available ||
        data.hideLink ||
        (isHST && (data.useHawaiiSplashMasking || data.useHawaiiTripMasking))
      ) {
        return;
      }
      tripLinks.push(
        <Link key={key} to={`/${key}/#top`}>
          {data.name} {data.year}
        </Link>
      );
    });

    return (
      <footer className={hideNewsletter && "no-newsletter"}>
        <div className="wrap">
          {!hideTrips && !!tripLinks.length && (
            <p className="menu">
              <strong>Getaways</strong>
              {tripLinks}
            </p>
          )}
          {!hideTrips && trip && (
            <p className={`menu for-trip ${trip}`}>
              <strong>About Love Song</strong>
              <Link to={`/${trip}/our-story/`}>Our Story</Link>
              <Link to={`/${trip}/contact-us/`}>Contact Us</Link>
            </p>
          )}
          {!hidePolicies && (
            <p className="menu">
              <strong>Policies</strong>
              <Link to="/policies/privacy/">Privacy</Link>
              {tripData && (
                <Link
                  to={`/policies/terms-${tripData.slug}${
                    tripData.termsVersion || ""
                  }/`}
                >
                  Terms
                </Link>
              )}
            </p>
          )}
          <p className="menu social">
            <strong>Connect</strong>
            <a
              target={isIOS ? undefined : "_blank"}
              href={config.urls[isIOS ? "facebookApp" : "facebook"]}
            >
              <i className="fa fa-facebook-square" />
            </a>
            <a
              target={isIOS ? undefined : "_blank"}
              href={config.urls[isIOS ? "instagramApp" : "instagram"]}
            >
              <i className="fa fa-instagram" />
            </a>
          </p>

          <p className="legal">
            &copy; Love Song 2001-{new Date().getFullYear()}
          </p>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/site-footer.js